import {
  type AgenticPlatformAskUserQuestion,
  AgenticPlatformAskUserQuestionSchema,
} from 'agentic-platform-schema';

/** A data part rather than a tool part, so every other tool keeps the package's tool card. */
export const AGENTIC_CHAT_QUESTION_PART_TYPE = 'data-ask-user';

/** The question carried by an ask-user tool call, or `undefined` when the arguments are unusable. */
export function parseAgenticChatQuestion(
  input: unknown
): AgenticPlatformAskUserQuestion | undefined {
  const question = AgenticPlatformAskUserQuestionSchema.safeParse(input);
  return question.success ? question.data : undefined;
}

interface AgenticChatQuestionPartData {
  data: AgenticPlatformAskUserQuestion;
  id: string;
  type: typeof AGENTIC_CHAT_QUESTION_PART_TYPE;
}

/** The part shape, which doubles as the stream chunk that adds it to a message. */
export function getAgenticChatQuestionPart(options: {
  id: string;
  question: AgenticPlatformAskUserQuestion;
}): AgenticChatQuestionPartData {
  return {
    data: options.question,
    id: options.id,
    type: AGENTIC_CHAT_QUESTION_PART_TYPE,
  };
}
